import { render } from "./LippudeMäng2.vue?vue&type=template&id=315d9af5&scoped=true"
import script from "./LippudeMäng2.vue?vue&type=script&lang=js"
export * from "./LippudeMäng2.vue?vue&type=script&lang=js"

import "./LippudeMäng2.vue?vue&type=style&index=0&id=315d9af5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315d9af5"]])

export default __exports__